export const MIN_BUDGET_RATIO = 10;
